import { Navigate } from "react-router";
import { AuthUser } from "../../models/user";
import { ReactElement } from "react";

type ProtectedRouteProps = {
  user: AuthUser | null;
  children: ReactElement<any, any>;
};

const ProtectedRoute = ({ user, children }: ProtectedRouteProps) => {
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
